import { Link } from '@components/atoms/Link/Link';
import { Meta } from '@components/atoms/MetaTags/Meta';
import { Title } from '@components/atoms/Title';
import { extractSsrState } from '@lib/graphql/helpers/extractSsrState';
import { createUrqlClient } from '@lib/graphql/urql';
import { GetRedirectPagesDocument } from '@src/lib/graphql/generated';
import Head from 'next/head';

export function RedirectSitemapIndex({ data, entry }) {
  return (
    <div>
      <Head>
        {Meta(
          {
            no_follow: false,
            no_index: true,
          },
          'Weiterleitungen',
        )}
      </Head>
      <Title classProps={{ heading: 'text-xl lg:text-xl mb-6' }} level={1}>
        {entry?.title ?? 'Sitemap - Weiterleitungen'}
      </Title>
      <div className="grid gap-2">
        <ul>
          {data?.pages.map((page) => (
            <li key={`redirect-${page.slug}`}>
              <Link href={page.slug}>{page.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export async function sitemapSsrLogic() {
  const { ssrQuery, ssrCache } = createUrqlClient();

  const { data: redirectsData } = await ssrQuery({
    query: GetRedirectPagesDocument,
    variables: { portal: 'tvmedia' },
  });

  const pages = [];

  for (let i = 0; i < redirectsData?.redirects?.paginatorInfo?.lastPage; i++) {
    pages.push({ title: `Seite ${i + 1} (${i * 60} - ${(i + 1) * 60 - 1})`, slug: `/sitemap-redirects/page-${i + 1}` });
  }

  const data = {
    pages: pages,
  };

  return {
    props: {
      data,
      slug: 'index',
      urqlState: extractSsrState(ssrCache),
    },
  };
}
